import React, { useRef } from 'react';

import clsx from 'clsx';
import styles from './Ingredients.module.scss';
import Text from '@/components/Text/Text';
import Icon from '@/components/Icon';
import { useResize } from '@/hooks/useResize';
import Button, { ButtonType } from '@/components/Button/Button';

export interface IAccordion {
  title: string;
  subtitle?: string;
  description?: string;
  link?: {
    title: string,
    link: string
  },
  toggleAccordion: () => void;
  isOpen: boolean;
  className?: string;
  iconStyle?: React.CSSProperties;
  children?: any;
  isTransparent?: boolean;
}
const BOTTOM_PADDING = 24;

const IngredientAccordion = ({
  title, subtitle, description, link, toggleAccordion, isOpen, className, iconStyle, children, isTransparent,
}: IAccordion) => {
  const contentRef = useRef<HTMLDivElement>(null);

  const updateHeight = () => {
    if (isTransparent) return;

    const el = contentRef.current;
    if (!el) return;

    if (isOpen) {
      el.style.maxHeight = `${el.scrollHeight + BOTTOM_PADDING}px`;
      el.style.opacity = '1';
    } else {
      el.style.maxHeight = '0px';
      el.style.opacity = '0';
    }
  };
  useResize(updateHeight, [isOpen]);

  return (
    <div className={clsx(styles.accordion, className, { [styles.isTransparent]: isTransparent })}>
      <header
        className={styles.accordion_header}
        onClick={toggleAccordion}
        role='presentation'
      >
        <div className={styles.headerText}>
          <Text
            tag='p'
            isBold
            className={styles.title}
          >
            {title}
          </Text>
          <Icon
            style={{ fontSize: 24, ...iconStyle }}
            className={clsx(styles.arrow, { [styles.open]: isOpen })}
            name='keyboard_arrow_down'
          />
        </div>
        {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
      </header>
      <div
        className={clsx(styles.accordion_content, {
          [styles.open]: isOpen,
        })}
        ref={contentRef}
      >
        {description ? (
          <p className={styles.content}>{description}</p>

        ) : (
          children
        )}
        {link && (
          <Button
            type={ButtonType.TEXT_LIGHT}
            iconName='arrow_forward'
            className={styles.cta}
            iconSize={20}
            href={link.link}
          >
            {link.title || 'Read more'}
          </Button>
        )}
      </div>
    </div>
  );
};

export default IngredientAccordion;
